export default __webpack_public_path__ + "static/media/phoneBack.0c764757.png";